import { useEffect } from 'react';

export default function useClickOutside(ref: React.RefObject<HTMLElement | null>, handler: (e: MouseEvent) => void, active = true) {
  useEffect(() => {
    if (!active) return;
    const listener = (e: MouseEvent) => {
      if (!ref.current) return;
      const target = e.target as Node;
      if (!ref.current.contains(target)) handler(e);
    };
    document.addEventListener('mousedown', listener);
    return () => document.removeEventListener('mousedown', listener);
  }, [ref, handler, active]);
}
